import 'twin.macro';

import { useState } from 'react';

import iconMinus from '../../assets/svgs/minus.svg';
import iconPlus from '../../assets/svgs/plus.svg';

const data1 = [
  {
    content: `This is a team event, you must enter as a team of 6 or 7.<br/>
  Team entry fee: $100 USDC/USDT (100% going to Jackpot Bonuses)<br/>
  Experience is not required to enter.`,
    title: 'OVERVIEW',
  },
  /**
   * 1st Place - $9,000<br/>
  2nd Place - $3,750<br/>
  3rd Place - $1,500<br/>
  4th Place - $750
   */
  {
    content: `<strong>All prizes will be paid in USDC, $15K + Jackpot Bonuses will be 100% paid out to players.</strong><br/>
The Prize Pool will be split among the top 3 finishers, breakdown details to be released when entries are finalized on 11/10.`,
    title: 'Prize Pools',
  },
  {
    content:
      'All Jackpot Bonus details to be released when entries are finalized on 11/11. 100% of entry fees will be paid out in Jackpot Bonuses.',
    title: 'Jackpot Bonuses',
  },
  {
    content: `The finals will be streamed live on Joystick's Twitch channel.<br/><br/> 
  Each team captain is required to stream every round in at least 720p 30 fps. There will be two quality checks prior to the event to ensure this is properly set up.`,
    title: 'Streaming',
  },
  {
    content:
      'The event will be run in English. If the team does not have anyone that speaks English, the team must provide a translator. The translator must be present for the entire time the team is playing, not having a translator available will result in immediate disqualification. Translation will be assumed to be accurate, and any rules broken will be considered intentional, mistranslation is not an excuse.',
    title: 'Communication',
  },
  {
    content: `ALL COMPETITORS WILL START AT LEVEL 0 ON BRAND NEW ACCOUNTS. Each player on each team will receive a new account as part of the registration process. These accounts will go live at the beginning of Round 1. Teams will then have 8 hours to collect as many NFTs as possible by killing mobs in Big Time.<br/><br/>
JOYSTICK'S NFT HUNT WILL BE A TWO (2) ROUND EVENTAt the end of Round 1, each player's NFTs found will be recorded. The six (6) teams with the highest NFT count will advance to the LIVE STREAMED FINALS on 11/19.  Each player on advancing teams will begin the Finals with a NEW ACCOUNT at Rank 0, leveling the playing field again. At the completion of JOYSTICK'S NFT HUNT: BIG TIME, game access will be revoked from all new accounts. Any NFTs found during the event will remain the property of the account holder.`,
    title: 'How to Win',
  },
  {
    content: `Round 1 is a play-in to qualify the top 6 teams for the finals.<br/>
    Every NFT found will be worth 1 point, regardless of rarity.<br/>
    The top 6 teams with the highest point totals at the end of play-in rounds will advance to the Finals.`,
    title: 'Scoring Format for Round 1',
  },
  {
    content: `Team captains (who must be streaming), upon team finding an NFT, will perform the “Emote of the Day” and type the secret phrase (provided the day of the event) into the in-game chat. The video of this NFT find must be clipped on Twitch, and the link submitted to Joystick admins immediately. Once play has completed, there will be a 1-hour submission period where teams will submit their NFT findings by filling out a provided form and sending it to Joystick admins.<br/><br/>
  Points will be tallied and results posted by Joystick.<br/><br/>  
  Notice: Joystick will take additional measures to ensure no cheating is allowed. Anyone found attempting to cheat the scoring system will be immediately disqualified.`,
    title: 'Confirming NFT Points',
  },
];
const data2 = [
  {
    content: `In the finals, scoring will be based on Rarity of NFTs found.<br/><br/>
  Uncommon NFT = 1 pt<br/>
  Rare NFT = 2 pts<br/>
  Epic NFT = 3 pts<br/>
  Legendary NFT = 4 pts<br/>
  Rare Space Small = 2 pts<br/>
  Rare Space Medium = 3 pts<br/>
  Rare Space Large = 4 pts<br/><br/>  
  Finals will be streamed live and all NFT finds monitored and confirmed on stream by teams & Joystick. Whichever team scores the most points by the end of the final round wins.<br/><br/>  
  In the final round, to incentivize correct and fair play, there will be two scenarios that result in lost points:<br/><br/>  
  Squad Wipes = -1 pt<br/>
  Failed or Skipped Dungeons = -1 pt<br/><br/>  
  There is only one time where the failed or skipped dungeons deduction will not happen:<br/><br/>  
  This is when a mob is in an unkillable position. If this happens, notify a Joystick admin who will jump into your stream to verify the mob is unkillable and give you the go-ahead to leave the dungeon penalty free.<br/><br/>  
  In any scenario, if the team captain doesn’t notify Joystick admins before they leave the dungeon, the penalty will always apply.`,
    title: 'Scoring Format For Finals',
  },
  {
    content: `All rounds will be played for eight (8) hours<br/>
    Round 1 will be played on Saturday, November 12th from 2pm - 10pm EST<br/>
    Round 2 (FINALS) will be played on Saturday, November 19th from 2pm - 10pm EST<br/>`,
    title: 'Dates / Times',
  },
  {
    content: `If an exploit is used the admin staff will notify the team and take away 1 point. If it happens a second time the team will be disqualified.<br/><br/>
  It is assumed that each team is aware of what is and is not an exploit in Big Time. If you are unsure if a strategy your team is planning to use is an exploit, reach out to the Joystick admin team before the tournament to clarify. Not being aware is not an excuse and the above process will still apply.
  `,
    title: 'No exploits allowed!',
  },
  {
    content: `In order to sub in a substitute (if your team has one) you must contact Joystick admins before doing so. The admin will give you the go-ahead. Keep in mind, this rule applies to get your original starting teammate back into play as well.
  `,
    title: 'Substitutes',
  },
  {
    content: `Tie Breakers will be decided by the team with the most Legendary NFTs looted.<br/><br/>
  Additional tie breakers (if needed) will be in this order:<br/>
  Total Space NFTs looted<br/>
  Total Epic NFTs looted<br/>
  Total Rare NFTs looted<br/><br/>  
  If there is still a tie both teams will run dungeons, with Joystick overseeing live streams, until the first team loots an nft to win.<br/><br/>  
  In the Finals the above tie breaker will be skipped and each team will play sudden death. First team to loot an nft wins.`,
    title: 'Tie Breakers',
  },
  {
    content: `<a href="https://discord.gg/joystickgaming" target="_blank" rel="noreferrer" style="border-bottom: 1px solid #fff8">Joystick Discord</a><br/>
    Admin: kingperrin1#0969<br/>
    Admin: Penta#1234<br/>
    Admin: ilikecookies#2432<br/>
    Admin: centercut#8201`,
    title: 'The Joystick Hunt will be organized and officiated by Joystick',
  },
  {
    content: `GeForce GTX 1060 or better / Radeon Rx 580 or better<br/>
  8GB RAM<br/>
  DirectX 11 or above<br/>
  Intel core i5 4430/ AMD FX 6300<br/>
  10GB available drive space`,
    title: 'Computer requirements - must be a PC',
  },
];

const legalDisclaimers = `
The organizer of the competition, including their business name, is indicated directly on the input screen for participation in the competition (hereinafter referred to as the ‘Organizer’).<br/>
(1) To the extent not provided otherwise, all persons who have reached the age of 18 are eligible to participate in the competition. Minors under the age of 18 may not participate. Prizes will not be distributed to minors whose participation is expressly prohibited.<br/>
(2) The participant is solely responsible for the accuracy of data related to participation in the competition. All personal information must be true. Otherwise, this may result in exclusion from the competition.<br/>
(3) Each participant may only enter the competition once. Multiple entries are prohibited. The Organizer reserves the right to exclude participants in the case of multiple entries in the competition.<br/>
(4) The Organizer reserves the right to exclude persons from the competition and not to pay out prizes, or to subsequently forfeit and reclaim them, in the event of a violation of these terms.<br/>
(5) Persons who use any illicit means, or otherwise seek advantage through manipulation, are likewise prohibited. If necessary, prizes may be subsequently forfeited and reclaimed in such cases.<br/>
(6) Anyone who provides false information about their identity or makes multiple entries in the competition is likewise excluded.<br/>
(7) Participation opportunities and rules, competitions, etc. that deviate from the competition mechanism described here will be communicated to participants directly on the participant web interface. To the extent not otherwise stated, these deviating provisions apply in such cases.<br/>
(8) Under no circumstance will cash alternatives for non-cash prizes or prize substitutions be offered.<br/>
(9) The right to the prize or prize substitution is not transferable.<br/>
(10) Complaints relating to the conduct of the competition must be submitted in writing to the Organizer along with an indication of the competition concerned within 14 days of becoming aware of the grounds. Complaints communicated by telephone or late complaints will not be processed.<br/>
(11) The Organizer reserves the right to cancel or terminate the competition at any time without prior notice and without the need to indicate the grounds. In particular, the Organizer may avail itself of this option should the proper conduct of the competition not be assured owing to technical causes (e.g. viruses in the computer system, manipulation or errors in the hardware and/or software) or legal reasons. The Organizer may demand that a participant pay compensation for any damages incurred if any such termination is caused by the conduct of a participant.<br/>
(12) The Organizer shall be released from all obligations upon fulfillment or distribution of the prize unless an earlier point in time has been specified by these provisions.<br/>
(13) The Organizer shall not be liable for insolvency on the part of a prize sponsor or the resulting consequences for conducting the competition.<br/>
(14) The Organizer is only liable for damages if such damages result from intent or gross negligence. The preceding limitation of liability applies in particular to damages caused by errors, delays or interruptions in the transmission of data, faults in technical equipment or services, incorrect content, loss or deletion of data, viruses or in any other way in the use of the application.<br/>
(15) The judges' decision is final.<br/>
(16) The laws of the Cayman Islands shall apply exclusively.<br/>
(17) Should any of these provisions be or become invalid, this shall not affect the validity of the remaining Terms and Conditions.<br/>
(18) These Terms and Conditions can be changed at any time by the Organizer without need for separate notification.`;

const Accordion = (props: { title: string; content: string }) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div tw="overflow-hidden">
      <div
        tw="flex justify-between items-center cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <h4 tw="text-lg tracking-normal uppercase">{props.title}</h4>
        <img
          alt=""
          src={expanded ? iconMinus : iconPlus}
          tw="transition-all"
          width={12}
        />
      </div>
      {/* {expanded && ( */}
      <p
        css={{
          maxHeight: expanded ? '100rem' : 0,
          paddingTop: expanded ? 20 : 0,
        }}
        dangerouslySetInnerHTML={{ __html: props.content }}
        tw="text-[16px] leading-[130%] text-[rgba(255,255,255,0.8)] box-border transition-all duration-300"
      />
      {/* )} */}
    </div>
  );
};

const EssaySection = () => {
  return (
    <div
      css={{ backgroundImage: 'url(/nft-hunt/images/essay-bg.jpg)' }}
      tw="pt-[60px] md:pt-[6.94vw] px-4 md:px-[8.33vw] pb-[8.33vw] relative w-full flex flex-col bg-no-repeat bg-top bg-cover"
    >
      <h3 tw="font-normal font-lumadFree text-[16px] md:text-[20px] leading-[140%] tracking-normal text-center md:text-left">
        EVENT RULES
      </h3>
      <div tw="pt-12 md:pt-[56px] pb-10 md:pb-20 grid grid-cols-1 md:grid-cols-2 gap-[2.84722vw]">
        <ul tw="flex flex-col gap-5">
          {data1.map((item, index) => (
            <li key={`l-${index}`}>
              <Accordion content={item.content} title={item.title} />
            </li>
          ))}
        </ul>
        <ul tw="flex flex-col gap-5">
          {data2.map((item, index) => (
            <li key={`r-${index}`}>
              <Accordion content={item.content} title={item.title} />
            </li>
          ))}
        </ul>
      </div>
      <div tw="pt-10 md:pt-20 border-t border-[rgba(255,255,255,0.2)]">
        <div tw="block md:hidden">
          <Accordion content={legalDisclaimers} title="Legal Disclaimers" />
        </div>
        <div tw="hidden md:block">
          <h4 tw="text-lg tracking-normal uppercase">Legal Disclaimers</h4>
          <p
            dangerouslySetInnerHTML={{ __html: legalDisclaimers }}
            tw="pt-6 text-[14px] leading-[130%] text-[rgba(255,255,255,0.8)]"
          />
        </div>
      </div>
    </div>
  );
};

export default EssaySection;
